import React, { useState } from "react";
import "./SignIn.css";
import more from "./more.png";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// loading spinner
import Backdrop from "@mui/material/Backdrop";
import HashLoader from "react-spinners/HashLoader";
import secureLocalStorage from  "react-secure-storage";


function SignIn() {
  //page loading
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();
  function handleClickNavigate() {
    navigate("/");
  }

  const [user, setuser] = useState({
    email: "",
    password: "",
  });

  function handlechange(event) {
    const { name, value } = event.target;
    setuser({
      ...user,
      [name]: value,
    });
  }


  async function loginSubmit(event) {
    let messageee = document.getElementById("messageee");
    event.preventDefault();
    setLoading(true);
    await axios.post("https://aware-slug-kerchief.cyclic.app/users/login-api", user).then((res) => {
      if (res.data.message === "Successful") {
        setTimeout(() => {
          handleClickNavigate();
        }, 100);
        const user = res.data.user;
        secureLocalStorage.setItem("user-info",user) // Store the user info securely
      } else if (res.data.message === "Password does not match") {
        messageee.textContent = "incorrect password";
      } else {
        messageee.textContent = "No User Found!";
      }
    });
    setLoading(false);
  }
  

  // top to page
  function toptopage() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  // remove incoreect pass msg
  function reomvemsgInpass() {
    let messageee = document.getElementById("messageee");
    messageee.textContent = "";
  }

  return (
    <div>
      <div className="login-login-main-container">
        <div className="login-login-div">
          <div className="login-upper-div-main">
            <h1 className="log-in-welcome">Welcome</h1>
            <div className="login-upper-div"></div>
            <img className="login-dot-hr" src={more} alt="" />
          </div>
          <div className="user-login-details-main">
            <form onSubmit={loginSubmit} className="user-login-details-sub">
              <input
                name="email"
                type="email"
                className="log-in-input-email login-input-fields"
                placeholder="Email"
                required
                onChange={(event) => {
                  handlechange(event);
                  reomvemsgInpass();
                }}
                value={user.email}
              />
              <input
                name="password"
                type="password"
                className="log-in-input-pass login-input-fields"
                placeholder="Password"
                autoComplete="off"
                required
                onChange={(event) => {
                  handlechange(event);
                  reomvemsgInpass();
                }}
                value={user.password}
              />
              <p className="pass-match-msg-log-in" id="messageee"></p>
              <button className="log-in-input-btn" type="submit">
                LOGIN
              </button>
              <div className="login-or-div">
                <p className="login-OR">OR</p>
                <p className="login-bottom-para">Don’t have an account?</p>
                <NavLink onClick={toptopage} to="/sign-up">
                  {" "}
                  <p className="login-sign">Sign Up</p>
                </NavLink>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div>
        {loading ? (
          <Backdrop
            sx={{
              color: "#ffffff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open
          >
            <HashLoader color="#21daa2" />
          </Backdrop>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default SignIn;
